import Swal, {SweetAlertResult, SweetAlertType} from "sweetalert2";
import i18n from "@/plugins/i18n";
import store from '@/store/'
import {cutErrors} from "./notify-utils";
import {declOfNum} from '@/utils/data-helper'

export function getErrorMessage(error: any) {
    let errorCode = parseInt(error.response.data.errorCode || error.response.data.error_code || 0)
    let errorMessage = error?.response?.data?.message;
    let errorContext = error?.response?.data?.errorContext || error?.response?.data?.error_context;
    let message = '';
    if (errorCode === 1) {
        message = i18n.tc('errors.internal')
        if (errorMessage && errorMessage.includes('File parse error: fields mismatch')) {
            message += `<br>${i18n.tc('errors.file_parse_error')}`
        }
    } else if (errorCode === 2) {
        message = i18n.tc('errors.request')
    } else if (errorCode === 3) {
        message = i18n.tc('errors.violation')
    } else if (errorCode === 4) {
        message = i18n.tc('errors.not_found')
    } else if (errorCode === 5) {
        message = i18n.tc('errors.invalid_credentials')
    } else if (errorCode === 6) {
        message = i18n.tc('errors.present_dependence')
    } else if (errorCode === 7) {
        message = i18n.tc('errors.invalid_email_address')
    } else if (errorCode === 8) {
        message = i18n.tc('errors.invalid_email_provider')
    } else if (errorCode === 9) {
        message = i18n.tc('errors.invalid_start_end_time')
    } else if (errorCode === 10) {
        message = i18n.tc('errors.invalid_file_name')
    } else if (errorCode === 11) {
        message = i18n.tc('errors.invalid_file_extension')
    } else if (errorCode === 12) {
        message = i18n.tc('errors.invalid_file_size')
    } else if (errorCode === 13) {
        message = i18n.tc('errors.invalid_call_sender')
    } else if (errorCode === 14) {
        message = i18n.tc('errors.invalid_sms_sender')
    } else if (errorCode === 15) {
        message = i18n.tc('errors.user_locked')
    } else if (errorCode === 16) {
        message = i18n.tc('errors.not_active_client')
    } else if (errorCode === 17) {
        message = i18n.tc('errors.draft_exists')
    } else if (errorCode === 18) {
        message = i18n.tc('errors.passwords_not_equals')
    } else if (errorCode === 19) {
        message = i18n.tc('errors.password_already_used')
    } else if (errorCode === 20) {
        message = i18n.tc("errors.password_difference_symbols") + ' '
            + declOfNum(parseInt(errorContext.minimalDifferentSymbolsNumber), i18n.tc('declensions.symbols').split('/'))
    } else if (errorCode === 21) {
        message = i18n.tc("errors.password_length") + ' '
            + declOfNum(parseInt(errorContext.minimalPasswordLength), i18n.tc('declensions.symbols').split('/'))
    } else if (errorCode === 22) {
        message = i18n.tc("errors.user_temporary_locked") + ' '
            + declOfNum(parseInt(errorContext.remainingLockTime), i18n.tc('declensions.minutes').split('/'))
    } else if (errorCode === 23) {
        message = i18n.t("errors.user_locked_by_system", [
            declOfNum(parseInt(errorContext.systemBlockingTimeout), i18n.tc('declensions.days').split('/'))
        ]).toString()
    } else if (errorCode === 28) {
        message = i18n.tc('errors.ad_connection_error')
    } else if (errorCode === 29) {
        message = i18n.tc('errors.ad_login_exist')
    } else if (errorCode === 31) {
        message = i18n.tc('errors.no_data_to_export')
    } else if (errorCode === 32) {
        let error_message_path = 'errors.loop_in_cascading_chain'
        if (error.response.data.path && error.response.data.path.endsWith('/template')) {
            error_message_path += '_template'
        }
        message = i18n.tc(error_message_path, errorContext)
    } else if (errorCode === 33) {
        message = i18n.tc('errors.addressbookcontact_duplicate')
    } else if (errorCode === 34) {
        message = i18n.tc('errors.blacklistcontact_duplicate')
    } else if (errorCode === 35) {
        message = i18n.tc('errors.active_directory_server_unavaible')
    } else if (errorCode === 39) {
        message = i18n.tc('errors.system_setting_value_is_not_set')
    } else if (errorCode === 40) {
        message = i18n.tc('errors.file_is_too_long')
    } else if (errorCode === 41) {
        message = i18n.tc('errors.change_password_link_expired')
    } else if (errorCode === 42) {
        message = i18n.tc('errors.captcha_verification_error')
    } else if (errorCode === 43) {
        message = i18n.tc('errors.no_partner_user_found')
    } else if (errorCode === 44) {
        message = i18n.tc('errors.change_password_limit')
    } else if (errorCode === 301) {
        message = i18n.tc('errors.internal')
    } else if (errorCode === 302) {
        let params = []
        if (errorContext?.parameter_name) {
            params = errorContext?.parameter_name.map((item: string) => {
                if (item == 'group_by') return i18n.tc('group_by') + '/' + i18n.tc('group_by_optionally')
                return i18n.tc(item)
            })
        }
        message = `${i18n.tc('errors.unable_data')} <br> ${params.join(', ')}`
    } else if (errorCode === 303) {
        message = i18n.tc('errors.invalid_date_format')
    } else if (errorCode === 304) {
        message = i18n.tc('errors.invalid_date_interval')
    } else if (errorCode === 308) {
        message = i18n.tc('errors.transport_not_allowed')
    } else if (errorCode === 309) {
        message = i18n.tc('errors.no_data_to_export')
    } else {
        message = i18n.tc('errors.internal')
    }
    return message
}

export function notifyError(error?: any, errors?: any, errorText?: string): void {
    let type: SweetAlertType = 'error';
    let message = '';

    switch (error?.response?.status) {
        case 400:
            if (error?.response?.data) {
                console.log(error?.response?.data)
                let errorCode = parseInt(error.response.data.errorCode || error.response.data.error_code || 0)
                if (errorCode === 31 || errorCode === 309) {
                    type = 'warning'
                }
                message = getErrorMessage(error)
            }
            break;
        case 401:
            return
        case 403:
            return
        case 502:
            message = i18n.tc('errors.server_unavaible')
            break;
    }
    // if (error && !message) {
    //     message = error?.response?.data?.status + ' ' + error?.response?.data?.error
    // }
    if (errors) {
        errors = cutErrors(errors); // TODO: после исправления повторений в валидационных сообщениях - эту штуку можно убрать
        for (let errorIndex in errors) {
            if (errors[errorIndex].length)
                message += `<br>${errors[errorIndex]}`
        }
    }
    if (errorText) {
        message += `<br>${errorText}`
    }
    Swal.fire({
        type: type,
        title: i18n.tc(`dialog.${type}`),
        html: message,
        confirmButtonClass: "md-button md-success",
        showConfirmButton: true
    });
}

export function notifyErrorCustom(message?: string): void {
    message = message ?? i18n.tc('dialog.success');
    Swal.fire({
        type: 'error',
        title: i18n.tc('dialog.error'),
        html: message,
        confirmButtonClass: "md-button md-success",
        showConfirmButton: true
    });
}

export function notifySuccess(message?: string): void {
    message = message ?? i18n.tc('dialog.success');
    Swal.fire({
        type: 'success',
        title: "",
        html: message,
        confirmButtonClass: "md-button md-success",
        showConfirmButton: true
    });
}

export function notifyConfirm(isChange: boolean, action: any, next: any) {
    if (!isChange) {
        next()
    } else {
        if (store.getters.isAuthenticated) {
            Swal.fire({
                type: "warning",
                title: i18n.tc('dialog.warning'),
                html: i18n.tc('dialog.confirm'),
                showCancelButton: true,
                confirmButtonClass: "md-button md-primary",
                cancelButtonClass: "md-button",
                confirmButtonText: i18n.tc('dialog.yes'),
                cancelButtonText: i18n.tc('dialog.no'),
                buttonsStyling: false,
                allowOutsideClick: false,
            }).then(result => {
                if (result.dismiss == Swal.DismissReason.esc) {
                    return next(false)
                }
                if (result.value) {
                    action().then(() => {
                        next()
                    })
                } else {
                    next()
                }
            });
        } else {
            next()
        }
    }
}

export async function notifyDelete(message?: string): Promise<boolean> {
    message = message ?? i18n.tc('dialog.delete');
    let result: SweetAlertResult = await Swal.fire({
        type: "warning",
        title: i18n.tc('dialog.warning'),
        html: message,
        showCancelButton: true,
        confirmButtonClass: "md-button md-primary",
        cancelButtonClass: "md-button",
        confirmButtonText: i18n.tc('dialog.yes'),
        cancelButtonText: i18n.tc('dialog.no'),
        buttonsStyling: false
    });
    return result.value;
}

export function notifyWarning(message?: string): void {
    message = message ?? i18n.tc('errors.no_data_to_show').toString()
    Swal.fire({
        type: 'warning',
        title: i18n.tc(`dialog.warning`),
        html: message,
        confirmButtonClass: "md-button md-success",
        showConfirmButton: true
    });
}